// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","vGray7":"#404040","item":"CustomSelectOption_item__1nBxa","item_active":"CustomSelectOption_item_active__1FOOA"};